import React from 'react';
import {withTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';
import OpenInNew from "@material-ui/icons/OpenInNew";
import FileScanIcon from "./FileScanIcon";

const styles = theme => ({
  buttonIcon: {
    marginBottom: -5,
  },
  mutedText: {
    color: '#bdbdbd',
  },
});

const FileAttachmentRow = ({ attachment, t, classes }) => (
  <>
    <FileScanIcon className={classes.buttonIcon} scan_status={attachment.scan_status}/>
    {attachment.scan_status === 'pass' && (
      <OpenInNew className={classes.buttonIcon}/>
    )}
    &nbsp;
    <span className={attachment.scan_status !== 'pass' ? classes.mutedText : ''}>{attachment.filename}</span>
  </>
);

export default withStyles(styles)(withTranslation()(FileAttachmentRow));
